/**
 * The top of a queue card: why it was flagged, what it is worth, who it
 * belongs to, and what it bought: a workshop, or gift passes.
 *
 * Split out of `ReviewQueueCard` so that file holds the card's shape and its
 * link behaviour rather than the contents of both halves.
 */
import { Gift, Ticket } from 'lucide-react';

import {
  customerLabel,
  formatMoney,
  purchaseDetailLine,
  purchaseLabel,
  reasonText,
} from '../reviewQueueModel';
import type { ReviewQueueItem } from '../reviewTypes';

export default function ReviewQueueCardHead({ item }: { item: ReviewQueueItem }) {
  const Icon = item.workshop ? Ticket : Gift;
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, color: 'var(--nb-ink-2)' }}>
          {reasonText(item.reviewReason)}
        </span>
        <span
          className="nb-tabular"
          style={{ fontSize: 14.5, fontWeight: 800, whiteSpace: 'nowrap' }}
        >
          {formatMoney(item.totalCents, item.currency)}
        </span>
      </div>
      <div style={{ marginTop: 9 }}>
        <div style={{ fontSize: 14.5, fontWeight: 700, color: 'var(--nb-ink)' }}>
          {customerLabel(item.customer)}
        </div>
        <div className="nb-mono" style={{ fontSize: 11, color: 'var(--nb-muted)', marginTop: 1 }}>
          {item.reference}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 7,
          marginTop: 4,
          fontSize: 12.5,
          color: 'var(--nb-muted)',
        }}
      >
        <Icon size={14} style={{ flex: '0 0 14px', color: 'var(--nb-muted)' }} />
        <span style={{ minWidth: 0 }}>
          {purchaseLabel(item.workshop)} · {purchaseDetailLine(item)}
        </span>
      </div>
    </>
  );
}
